import AdoptionSurvey from "components/AdoptionSurvey";
import survey, { htmlElement } from "config/survey";
import theme from "config/theme";
import styled from "styled-components";
import Animation from "./Animation";
import html2canvas from "html2canvas";
import { rootNode } from "index";

const Container = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 1rem;
    padding-top: 2rem;
`

const PrintButton = styled.div`
    background-color: ${theme.colors.primary};
    color: #fff;
    padding: 1rem 2rem;
    border-radius: 10px;

    &:hover {
        filter: brightness(0.8);
        cursor: pointer;
    }
`

const AdoptionFormResults = ({results}) => {

    const applicationId = Math.floor(Math.random() * 100000000);

    console.log({results});

    const flattenedSurvey = {
        elements: survey.pages.map(page => {
            return [
                htmlElement(`<br /><h2>${page.title}</h2>`),
                ...page.elements
            ]
        }).flat()
    }

    const handlePrint = () => {
        window.print();
    }

    const handleScreenshot = () => {

        html2canvas(rootNode, {
            scrollX: 0,
            scrollY: 0,
            backgroundColor: '#fff',
            height: document.body.scrollHeight,
            width: window.visualViewport.width
        })
        .then((canvas) => {
            const link = document.createElement('a')
            link.download = `adoption-preferences-${applicationId}.png`
            link.href = canvas.toDataURL("image/png").replace("image/png", "image/octet-stream");
            link.click()
        })
        .catch((err) => {
            console.log(err)
        })
    }

    return (
        <Container>
            <Animation />
            <div>Great job, Little One!</div>
            <div>Your Adoption Officer will contact you for next steps.</div>
            <div>We will look forward to meeting you in Tulna!</div>
            <div>Application No: {applicationId}</div>
            <PrintButton onClick={handlePrint}>Print Your Results</PrintButton>
            <PrintButton onClick={handleScreenshot}>Save As PNG</PrintButton>
            <AdoptionSurvey 
                survey={flattenedSurvey} 
                data={results} 
                isComplete 
            />
        </Container>
    )

}

export default AdoptionFormResults;